// Angular
import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Local library
import {
  RaceStringToRangePipe,
  GetCurrentRacePipe,
  GetRaceStatusPipe,
  SortEventsPipe,
  GetEventStatusPipe,
  GetTrackTypePipe,
  ConvertToRangePipe,
  LegHeightDirective,
  OrdinalsPipe,
  HorseWeightPipe,
  NumberWithCommasPipe,
  CountdownPipe,
  FormatAmountPipe,
  SanitizerPipe,
  UnsubscribeObservableService,
  MatNotificationService,
TranslatePipe
} from '@amwager/util';
import { CommonFacade, PermissionService, SessionService } from '@amwager/data-access';
import { GUEST, IGetEventsDetailsResponse, IPool, IRace, LoggerService } from '@amwager/util-ts';
import { RaceFinalComponent } from '@amwager/wager/ui-ion';
import {
  ISelectedRace,
  ISelectedRaceMatrix,
  RaceService,
  WagerFacade
} from '@amwager/wager/data-access';
import { AccountFacade } from '@amwager/account/data-access';

// Angular Material Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

// Third party
// import * as _ from 'lodash';
import _ from 'lodash';
import { take, takeUntil } from 'rxjs';

@Component({
  selector: 'feature-mat-modifier',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RaceStringToRangePipe,
    GetCurrentRacePipe,
    GetRaceStatusPipe,
    SortEventsPipe,
    GetEventStatusPipe,
    GetTrackTypePipe,
    ConvertToRangePipe,
    LegHeightDirective,
    OrdinalsPipe,
    HorseWeightPipe,
    // RunnerComponent,
    RaceFinalComponent,
    NumberWithCommasPipe,
    // MatrixComponent,
    CountdownPipe,
    FormatAmountPipe,
    SanitizerPipe,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    TranslatePipe
  ],
  providers: [DatePipe],
  templateUrl: './modifier.component.html',
  styleUrls: ['./modifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifierComponent extends
UnsubscribeObservableService implements OnInit, OnChanges {
  @Input() selectedEvent!: IGetEventsDetailsResponse;
  @Input() selectedPool!: IPool;
  @Output() doGetModifierFn = new EventEmitter<string>();

  selectedRace!: ISelectedRace;
  poolMatrix!: any;
  selectedModifier: string = '';
  pool!: string;
  modifier!: string;
  dblPkArray!: any;
  poolIds: string[] = ['EX','QU','TRL','TRI','SPR','OMN','PEN','HEX'];
  modifierIds: string[] = ['','BX','KB','PB','KW','DutchCost','ABC'];

  isExoticSelections!: boolean;

  runId!: string;
  eventId!: string;
  raceId!: string;

  private previousSelectedEventID!: string;
  private previousSelectedRaceID!: string;

  // Race the modifier was last reset for; distinguishes a real
  // race/event switch from a same-race pusher refresh.
  private currentRaceKey?: string;

  constructor(
    readonly cdRef: ChangeDetectorRef,
    readonly permissionService: PermissionService,
    private readonly sessionService: SessionService,
    readonly router: Router,
    private readonly elementRef: ElementRef,
    readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly commonFacade: CommonFacade,
    private readonly matNotificationService: MatNotificationService,
    private readonly raceService: RaceService,
    private readonly loggerService: LoggerService,
  ) {
    super();

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback === undefined) return;

        const response = callback?.response?.AccountPreferences;
        this.isExoticSelections = response?.IsExoticSelections;
        this.cdRef.markForCheck();
      });

    this.wagerFacade.getSelectedRace$().subscribe((race?: ISelectedRace) => {

        if (!race || !race?.RaceId || !race?.runId || !race?.eventId) return;

        this.selectedRace = race;

        // Reset to straight only when the race/event actually changes,
        // not on same-race pusher refreshes.
        const raceKey = `${race.eventId}-${race.RaceId}-${race.runId}`;
        if (raceKey !== this.currentRaceKey) {
          this.currentRaceKey = raceKey;
          this.selectedModifier = '';
          this.doGetModifierFn.emit(this.selectedModifier);
        }

        this.cdRef.markForCheck();
      });

    this.wagerFacade.getRaceMatrix$()
      .subscribe((callback) => {

        if (callback === undefined) return;

        this.poolMatrix = callback;
        this.cdRef.markForCheck();
      });

  }

  /**
   * Init on load
   * @returns {void}
   */
  ngOnInit(): void {
    this.pool = '';
  }

  /**
   * Init after view loaded
   * @param {any} changes listen to data changes
   * @returns {void}
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (
      changes['selectedEvent'] !== undefined &&
      changes['selectedEvent'].currentValue !== undefined
    ) {

      // proceed if selected event ID is not the same from Parent input
      // skip if selected event ID is the same from Parent input
      if (
        // if different event ID
        changes['selectedEvent'].currentValue.id !== this.previousSelectedEventID
      ) {
        this.previousSelectedEventID = changes['selectedEvent'].currentValue.id;
        // this.raceService.setDefaultValues(
        //   this.selectedRace?.RaceId || 0,
        //   this.swipeRaceSectionTemplateRef,
        //   this.doSetRaceStatusFn
        // );

        this.selectedModifier = '';

      } else this.loggerService.log('POOL:onchanges:POOL:ERROR',);

      if (
        changes['selectedEvent'].currentValue?.ToteResponse?.EventDetail?.currentRace?.RaceId
        !== this.previousSelectedRaceID
      ) {
        this.previousSelectedRaceID
          = changes['selectedEvent'].currentValue?.ToteResponse?.EventDetail?.currentRace?.RaceId;
        // this.raceService.setDefaultValues(
        //   this.selectedRace?.RaceId || 0,
        //   this.swipeRaceSectionTemplateRef,
        //   this.doSetRaceStatusFn
        // );

        this.selectedModifier = '';
      }

    }

    if (changes['selectedPool'] !== undefined)
    {
      const prevPool = changes['selectedPool'].previousValue;
      const currPool = changes['selectedPool'].currentValue;

      // Reset to straight only when the pool actually changes — a
      // same-pool reference refresh (pusher) keeps the user's modifier.
      if (currPool && currPool?.PoolId !== prevPool?.PoolId) {
        this.selectedModifier = '';
        this.doGetModifierFn.emit(this.selectedModifier);
      }
    }

    this.cdRef.markForCheck();
  }

  /**
   * Set event modifier
   * @param {any} modifier current DOM element
   * @returns {void}
   */
  selectModifier(modifier: any): void {

    if (
      !this.isExoticSelections ||
      !this.raceService.checkExotic(
        this.selectedPool.PoolId, this.isExoticSelections, this.poolIds, this.selectedPool
      )
    ) {
      this.raceService.clearActiveAllLeg(this.elementRef);
      this.raceService.clearLegRoundSelector(this.elementRef);
    }

    switch(modifier) {
      case 'Box':
          modifier = 'BX'
        break;
      case 'KeyBox':
          modifier = 'KB'
        break;
      case 'PowerBox':
          modifier = 'PB'
        break;
      case 'KeyWheel':
          modifier = 'KW'
        break;
      case 'DutchCost':
          modifier = 'DutchCost'
        break;
      case 'ABC':
          modifier = 'ABC'
        break;
      default:
          modifier = ''
        break;
    }

    this.selectedModifier = modifier;
    this.doGetModifierFn.emit(modifier);
    this.cdRef.markForCheck(); // re-render for template
  }

}
